module.exports = require("./fa-IR");